module.exports = __webpack_public_path__ + "img/arrow-up.957f56ef.svg";